import React, { useEffect, useRef, useState } from 'react'
import useScrollTop from '../hooks/useScrollTop'
import { Slider } from '../components';
import slider_image from '../assets/img/contact_image1.jpg';
import FeatherIcon from 'feather-icons-react';
import message_gif from '../assets/img/message.jpg';
import { Spinner } from 'flowbite-react';
import Swal from 'sweetalert2';
import axios from 'axios';
import useDocTitle from '../hooks/useDocTitle';


const ContactPage = () => {
    useScrollTop();
    useDocTitle("Contact us")

    const [isLoading, setIsLoading] = useState(false);
    const formRef = useRef();

    const [IP, setIP] = useState('');
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const resetForm = () => {
        setName('')
        setEmail('')
        setMessage('')
    }

    const handleSendMessage = (e) => {
        e.preventDefault();
        setIsLoading(true);

        const body = new FormData();
        body.append('entry.1140221610', IP);
        body.append('entry.1811125599', name);
        body.append('entry.599195461', email);
        body.append('entry.2015874026', message);

        var url = "https://docs.google.com/forms/u/0/d/e/1FAIpQLSeX4B4ovkNVDHjS879-PlI5Xq6v1n1r17S97Ckz1jh5STquog/formResponse"

        axios.post(url, body)
        .then(response => {
            setIsLoading(false);
            resetForm();
            Swal.fire({
                icon: 'success',
                title: 'Message successfully sanded',
            })
            console.log('response', response);
            
        }).catch(err => {
            setIsLoading(false);
            console.log('err', err);
        })
        
    }

    useEffect(() => {
        axios.get('https://api.ipify.org/?format=json')
        .then(response => {
            setIP(response.data.ip);
        }).catch(e => {})
    },[])

    return (
        <div className='bg-gray-50'>

            <Slider image={slider_image}/>

            <section className="py-10 px-2 md:px-8 lg:px-12">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                    <div className="shadow-md bg-white p-2 md:p-6 animate__animated animate__zoomInUp">
                        <div className="p-2 shadow-sm bg-slate-900 mb-5">
                            <h6 className="text-center text-white">Contact info</h6>
                        </div>
                        <div className="flex items-center gap-2 py-2">
                            <FeatherIcon icon="phone" className='text-slate-900' size={18}/>
                            <div className=""><span>+8801770826205</span></div>
                        </div>
                        <div className="flex items-center gap-2 py-2">
                            <FeatherIcon icon="mail" className='text-slate-900' size={18}/>
                            <div className=""><span>nakuldeb.cse.ru@gmail.com</span></div>
                        </div>
                        <div className="flex items-center gap-2 py-2">
                            <FeatherIcon icon="map-pin" className='text-slate-900' size={18}/>
                            <div className=""><span>Ring Road, Mohammadpur, Dhaka</span></div>
                        </div>
                        <div className=""  style={{
                            backgroundImage: "url(" + message_gif + ")",
                            height: 200,
                            backgroundPosition: 'center',
                            backgroundSize: '60%',
                            backgroundRepeat: 'no-repeat'
                        }}></div>
                    </div>

                    <div className="shadow-md bg-white p-2 md:p-6 animate__animated animate__zoomInUp">
                        <div className="p-2 shadow-sm bg-slate-900 mb-5">
                            <h6 className="text-center text-white">Send Message</h6>
                        </div>

                        <form ref={formRef} onSubmit={handleSendMessage} id="message-form" className="text-sm">
                            <input type="hidden" name="entry.1140221610" value={IP}/>
                            <fieldset className='p-2 my-5 border-2 rounded border-purple-400 hover:border-purple-600 hover:shadow'>
                                <legend className="px-1 font-semibold text-gray-600">Your Full Name</legend>
                                <input value={name} onChange={(e) => setName(e.target.value)} name="entry.1811125599" className="w-full border-0 outline-none focus:ring-0" type="text" required/>
                            </fieldset>

                            <fieldset className='p-2 my-5 border-2 rounded border-purple-400 hover:border-purple-600 hover:shadow'>
                                <legend className="px-1 font-semibold text-gray-600">Your Email</legend>
                                <input value={email} onChange={(e) => setEmail(e.target.value)} name="entry.599195461" className="w-full border-0 outline-none focus:ring-0" type="email" required/>
                            </fieldset>

                            <fieldset className='p-2 my-5 border-2 rounded border-purple-400 hover:border-purple-600 hover:shadow'>
                                <legend className="px-1 font-semibold text-gray-600">Message</legend>
                                <textarea value={message} onChange={(e) => setMessage(e.target.value)} name="entry.2015874026" className="w-full border-0 outline-none focus:ring-0" cols="30" rows="5" required></textarea>
                            </fieldset>

                            <div className="flex justify-end">
                                <button type="submit" className=' bg-teal-700 px-8 py-2 text-white fw-bold rounded-sm disabled:bg-teal-400 focus:bg-teal-500' disabled={isLoading}>
                                    {isLoading ? (<>
                                        <span className='pr-2'>Sanding</span>
                                        <Spinner aria-label="Default status example" />
                                    </>):(
                                        'Send'
                                    )}
                                </button>
                            </div>
                        </form>

                    </div>
                </div>
            </section>
        </div>
    )
}

export default ContactPage